import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import ProductService from "../services/ProductService";
import { IProduct } from "../types/Product";


interface ProductState {
    products: IProduct[];
    loading: boolean;
    error: string | null;
}

const initialState: ProductState = {
    products: [],
    loading: false,
    error: null,
};

export const fetchProducts = createAsyncThunk("products/fetchProducts", async () => {
    const products = await ProductService.fetchAllProducts();
    return products;
});

const productSlice = createSlice({
    name: "products",
    initialState,
    reducers: {
        // Add any necessary reducer actions here (e.g., filterProducts, searchProducts)
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProducts.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProducts.fulfilled, (state, action: PayloadAction<IProduct[]>) => {
                state.products = action.payload;
                state.loading = false;
            })
            .addCase(fetchProducts.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to fetch products";
            });
    },
});

export default productSlice.reducer;